module.exports = __webpack_public_path__ + "static/media/HB4@2x.5b979066.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/HB/HB4@2x.png
// module id = 280
// module chunks = 0